// Utility functions for custom key
export const generateInvoiceKey = (invoiceNumber: string, clientName: string): string => {
  // Remove spaces and special characters from client name for the key
  const sanitizedClientName = clientName.replace(/[^a-zA-Z0-9]/g, '');
  return `${invoiceNumber}-${sanitizedClientName}`;
};

export const generateClientKey = (name: string, uniqueId: string): string => {
  // Remove spaces and special characters from name for the key
  const sanitizedName = name.replace(/[^a-zA-Z0-9]/g, '');
  return `${sanitizedName}-${uniqueId}`;
};

export const generateManualLedgerKey = (companyName: string): string => {
  // Remove spaces and special characters from company name
  const sanitizedCompanyName = companyName.replace(/[^a-zA-Z0-9]/g, '');
  // Generate 6 random digits
  const sixDigits = Math.floor(100000 + Math.random() * 900000).toString();
  return `${sanitizedCompanyName}-${sixDigits}`;
};

export const generateLedgerKey = (name: string): string => {
  // Remove spaces and special characters from name
  const sanitizedName = name.replace(/[^a-zA-Z0-9]/g, '');
  // Generate 6 random digits
  const sixDigits = Math.floor(100000 + Math.random() * 900000).toString();
  return `${sanitizedName}-${sixDigits}`;
};
